import { createContext, type RefObject } from "react";

import type { FloatingPopoverPosition } from "./popover";

// popup의 React 자손으로 열린 레이어(popup·modal)는 다른 portal DOM에 놓이지만 그 popup의 내부
// 입력이다. 자손은 자기 DOM root를 모든 조상 popup에 등록하고, 조상은 그 root를 outside dismiss
// 안쪽으로 본다. `consumesEscape`인 자손이 열려 있는 동안 조상은 Escape로 닫히지 않는다.
export type PopupDescendant = { ref: RefObject<HTMLElement | null>; consumesEscape: boolean };
export type RegisterPopupDescendant = (entry: PopupDescendant) => () => void;

export const PopupOwnerContext = createContext<{
  register: RegisterPopupDescendant;
  // 소유 popup의 현재 위치. 자손 popup이 소유자가 움직일 때 anchor를 다시 측정하는 데 쓴다.
  position: FloatingPopoverPosition;
} | null>(null);
